export const CORE_GET_ALL_CAR_TYPE_REQUEST = 'CORE_GET_ALL_CAR_TYPE_REQUEST';
export const CORE_GET_ALL_CAR_TYPE_SUCCESS = 'CORE_GET_ALL_CAR_TYPE_SUCCESS';
export const CORE_GET_ALL_CAR_TYPE_FAILURE = 'CORE_GET_ALL_CAR_TYPE_FAILURE';

export const CORE_GET_CAR_TYPE_BY_ID_REQUEST = 'CORE_GET_CAR_TYPE_BY_ID_REQUEST';
export const CORE_GET_CAR_TYPE_BY_ID_SUCCESS = 'CORE_GET_CAR_TYPE_BY_ID_SUCCESS';
export const CORE_GET_CAR_TYPE_BY_ID_FAILURE = 'CORE_GET_CAR_TYPE_BY_ID_FAILURE';

export const CORE_GET_MASTER_CAR_TYPE_REQUEST = 'CORE_GET_MASTER_CAR_TYPE_REQUEST';
export const CORE_GET_MASTER_CAR_TYPE_SUCCESS = 'CORE_GET_MASTER_CAR_TYPE_SUCCESS';
export const CORE_GET_MASTER_CAR_TYPE_FAILURE = 'CORE_GET_MASTER_CAR_TYPE_FAILURE';

export const CORE_CREATE_CAR_TYPE_REQUEST = 'CORE_CREATE_CAR_TYPE_REQUEST';
export const CORE_CREATE_CAR_TYPE_SUCCESS = 'CORE_CREATE_CAR_TYPE_SUCCESS';
export const CORE_CREATE_CAR_TYPE_FAILURE = 'CORE_CREATE_CAR_TYPE_FAILURE';

export const CORE_UPDATE_CAR_TYPE_REQUEST = 'CORE_UPDATE_CAR_TYPE_REQUEST';
export const CORE_UPDATE_CAR_TYPE_SUCCESS = 'CORE_UPDATE_CAR_TYPE_SUCCESS';
export const CORE_UPDATE_CAR_TYPE_FAILURE = 'CORE_UPDATE_CAR_TYPE_FAILURE';

export const CORE_GET_ALL_CAR_REQUEST = 'CORE_GET_ALL_CAR_REQUEST';
export const CORE_GET_ALL_CAR_SUCCESS = 'CORE_GET_ALL_CAR_SUCCESS';
export const CORE_GET_ALL_CAR_FAILURE = 'CORE_GET_ALL_CAR_FAILURE';

export const CORE_GET_ALL_FUEL_REQUEST = 'CORE_GET_ALL_FUEL_REQUEST';
export const CORE_GET_ALL_FUEL_SUCCESS = 'CORE_GET_ALL_FUEL_SUCCESS';
export const CORE_GET_ALL_FUEL_FAILURE = 'CORE_GET_ALL_FUEL_FAILURE';

export const CORE_GET_CAR_BY_ID_REQUEST = 'CORE_GET_CAR_BY_ID_REQUEST';
export const CORE_GET_CAR_BY_ID_SUCCESS = 'CORE_GET_CAR_BY_ID_SUCCESS';
export const CORE_GET_CAR_BY_ID_FAILURE = 'CORE_GET_CAR_BY_ID_FAILURE';

export const CORE_CREATE_CAR_REQUEST = 'CORE_CREATE_CAR_REQUEST';
export const CORE_CREATE_CAR_SUCCESS = 'CORE_CREATE_CAR_SUCCESS';
export const CORE_CREATE_CAR_FAILURE = 'CORE_CREATE_CAR_FAILURE';

export const CORE_UPDATE_CAR_REQUEST = 'CORE_UPDATE_CAR_REQUEST';
export const CORE_UPDATE_CAR_SUCCESS = 'CORE_UPDATE_CAR_SUCCESS';
export const CORE_UPDATE_CAR_FAILURE = 'CORE_UPDATE_CAR_FAILURE';

export const CORE_GET_ALL_CAR_DRIVER_REQUEST = 'CORE_GET_ALL_CAR_DRIVER_REQUEST';
export const CORE_GET_ALL_CAR_DRIVER_SUCCESS = 'CORE_GET_ALL_CAR_DRIVER_SUCCESS';
export const CORE_GET_ALL_CAR_DRIVER_FAILURE = 'CORE_GET_ALL_CAR_DRIVER_FAILURE';

export const CORE_UPDATE_CAR_DRIVER_REQUEST = 'CORE_UPDATE_CAR_DRIVER_REQUEST';
export const CORE_UPDATE_CAR_DRIVER_SUCCESS = 'CORE_UPDATE_CAR_DRIVER_SUCCESS';
export const CORE_UPDATE_CAR_DRIVER_FAILURE = 'CORE_UPDATE_CAR_DRIVER_FAILURE';

export const CORE_GET_ALL_CAR_DRIVER_FREE_REQUEST = 'CORE_GET_ALL_CAR_DRIVER_FREE_REQUEST';
export const CORE_GET_ALL_CAR_DRIVER_FREE_SUCCESS = 'CORE_GET_ALL_CAR_DRIVER_FREE_SUCCESS';
export const CORE_GET_ALL_CAR_DRIVER_FREE_FAILURE = 'CORE_GET_ALL_CAR_DRIVER_FREE_FAILURE';

export const CORE_GET_ALL_MY_JOB_DRIVER_REQUEST = 'CORE_GET_ALL_MY_JOB_DRIVER_REQUEST';
export const CORE_GET_ALL_MY_JOB_DRIVER_SUCCESS = 'CORE_GET_ALL_MY_JOB_DRIVER_SUCCESS';
export const CORE_GET_ALL_MY_JOB_DRIVER_FAILURE = 'CORE_GET_ALL_MY_JOB_DRIVER_FAILURE';

export const CORE_UPDATE_ACTIVE_CAR_REQUEST = 'CORE_UPDATE_ACTIVE_CAR_REQUEST';
export const CORE_UPDATE_ACTIVE_CAR_SUCCESS = 'CORE_UPDATE_ACTIVE_CAR_SUCCESS';
export const CORE_UPDATE_ACTIVE_CAR_FAILURE = 'CORE_UPDATE_ACTIVE_CAR_FAILURE';

export const CORE_GET_CAR_RESERVE_BY_ID_REQUEST = 'CORE_GET_CAR_RESERVE_BY_ID_REQUEST';
export const CORE_GET_CAR_RESERVE_BY_ID_SUCCESS = 'CORE_GET_CAR_RESERVE_BY_ID_SUCCESS';
export const CORE_GET_CAR_RESERVE_BY_ID_FAILURE = 'CORE_GET_CAR_RESERVE_BY_ID_FAILURE';

export const CORE_DELETE_CAR_REQUEST = 'CORE_DELETE_CAR_REQUEST';
export const CORE_DELETE_CAR_SUCCESS = 'CORE_DELETE_CAR_SUCCESS';
export const CORE_DELETE_CAR_FAILURE = 'CORE_DELETE_CAR_FAILURE';



// WEBPACK FOOTER //
// ./src/app/redux/carReservationType.js